import { IonCol, IonGrid, IonRow } from '@ionic/react'

import './home.scss'
import 'swiper/scss'
import { BaseButton, CitiesCarousel, ResidenceCardGrid, ResidenceCardSkeletonGrid, SearchForm } from 'components'
import { useCallback, useState } from 'react'
import { useCities, usePageTitle, useSearch } from 'hooks'
import logo_negativo from 'theme/images/logo_negativo.svg'
import { Trans, useTranslation } from 'react-i18next'
import { Link, Redirect } from 'react-router-dom'
import { imageService, residenceService, routeService, stringService, transformerService } from 'services'
import { ISearchParams } from 'interfaces'
import qs from 'qs'
import BasePage from 'pages/base-page/base-page.page'

const HOME_BODY_CLASS = 'edisu-page-home'
const HEADER_NEGATIVE_CLASS = 'header-on-top'

const SEARCH_PARAMS: ISearchParams = {
  offset: 0,
  limit: 4,
}

const Home: React.FC = () => {
  const [bodyClasses, setBodyClasses] = useState([HOME_BODY_CLASS, HEADER_NEGATIVE_CLASS])
  const [searchQueryString, setSearchQueryString] = useState<string>()

  const cities = useCities()
  const searchResults = useSearch(SEARCH_PARAMS)

  const { t } = useTranslation()

  const titlePage = stringService.capitalizeFirstLetter(t('site_name'))
  usePageTitle(titlePage!)

  const onSubmitSearch = useCallback((searchParams: ISearchParams) => {
    const query_obj = transformerService.toISearchQueryString(
      searchParams.profileTypeId,
      searchParams.cityId,
      searchParams.dateFrom,
      searchParams.dateTo,
      searchParams.eventCode,
      searchParams.guestsPerRoom,
    )
    setSearchQueryString(qs.stringify(query_obj))
  }, [])

  if (searchQueryString) return <Redirect to={routeService.generateRoutePath('/search') + '?' + searchQueryString} />

  return (
    <BasePage
      pageClass={bodyClasses}
      headerLogo={bodyClasses.findIndex((c) => c === HEADER_NEGATIVE_CLASS) !== -1 ? logo_negativo : undefined}
    >
      <IonGrid className="welcome-grid">
        <IonRow className="welcome">
          <IonCol size="12" sizeMd="6">
            <IonRow className="ion-justify-content-center">
              <IonCol size="12" sizeLg="9" className="welcome-text-col">
                <h2>
                  <Trans i18nKey="welcome_campus">
                    First line. <br /> Second line
                  </Trans>
                </h2>
                <div className="welcome-text">
                  <p>{t('welcome_text_1')}</p>
                  <p>{t('welcome_text_2')}</p>
                  <Link className="discover-us-link" to={routeService.generateRoutePath('/about')}>
                    <BaseButton label={t('discover_us')} />
                  </Link>
                </div>
              </IonCol>
            </IonRow>
          </IonCol>
          <IonCol size="12" sizeMd="6">
            <CitiesCarousel
              header={<p className="edisu-text ion-hide-sm-down">{t('cities_where_stay')}</p>}
              items={
                cities
                  ? cities.map((c) => {
                      return {
                        id: c.id,
                        text: c.nome,
                        image: imageService.getCityMainImgUrl(c),
                      }
                    })
                  : []
              }
            />
          </IonCol>
        </IonRow>
      </IonGrid>

      <div className="img-wrapper">
        <div className="img-cnt">
          <img src="/assets/img/Torino.png" alt="bgImg" />
          <div className="opacity" />
        </div>
        <div className="search-cnt">
          <p className="edisu-text text-1">{t('where_booking')}</p>
          <SearchForm defaultParams={residenceService.getDefaultSearchParams()} onSubmitFunction={onSubmitSearch} />
        </div>
      </div>

      <div className="our-residences mobile-spaced ">
        <ResidenceCardGrid
          mobileAsSlider={true}
          residences={searchResults?.data?.map((residence) => {
            return { residence }
          })}
          header={<span className="edisu-text">{t('scopri_strutture')}</span>}
          footer={
            <div className="ion-padding show-all-wrapper">
              <Link className="discover-us-link" to={routeService.generateRoutePath('/residences')}>
                <BaseButton label={t('show_all')} />
              </Link>
            </div>
          }
          loadingComponent={
            searchResults?.data ? undefined : (
              <>
                <div className="ion-hide-lg-down">
                  <ResidenceCardSkeletonGrid count={4} />
                </div>
                <div className="ion-hide-lg-up">
                  <ResidenceCardSkeletonGrid count={1} />
                </div>
              </>
            )
          }
        />
      </div>
    </BasePage>
  )
}

export default Home
